import { apiClient, getHeaders } from '@/services/axiosConfig'

export default {
  getBranchesForCheckout (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/general/checkout/branches',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  }
}
